import React, { useState } from 'react';
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Form,
  Button,
} from 'reactstrap';
import PropTypes from 'prop-types';
import LaddaButton, { EXPAND_RIGHT } from 'react-ladda';
import { FormField } from '../../../utils/FormFields';

const ModalPersonalReference = ({
  open,
  toggle,
  saving,
  onSave,
}) => {
  const [newReference, setNewReference] = useState({
    AccountPersonalReferenceId: 0,
    AccountPersonalReferenceName: '',
    AccountPersonalReferencePhone: '',
  });

  const handleChange = (name, value) => {
    setNewReference({
      ...newReference,
      [name]: value,
    });
  };

  return (
    <Modal isOpen={open} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        Add New Personal Reference
      </ModalHeader>
      <ModalBody>
        <Form>
          <FormField
            label="Name: "
            value={newReference.AccountPersonalReferenceName}
            name="AccountPersonalReferenceName"
            onChange={handleChange}
          />
          <FormField
            label="Phone: "
            type="tel"
            value={newReference.AccountPersonalReferencePhone}
            name="AccountPersonalReferencePhone"
            onChange={handleChange}
          />
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button
          color="secondary"
          onClick={toggle}
        >
          Cancel
        </Button>
        <LaddaButton
          className="btn btn-ladda btn-primary"
          loading={saving}

          onClick={() => onSave(newReference)}
          data-style={EXPAND_RIGHT}
        >
          {saving ? ' Saving' : ' Save'}
        </LaddaButton>
      </ModalFooter>
    </Modal>
  );
};

ModalPersonalReference.propTypes = {
  open: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired,
  onSave: PropTypes.bool.isRequired,
};

export default ModalPersonalReference;
